import { ZfBox, ZfDropdown, ZfDropdownItem } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { useNumberSearchParams } from '../../hooks/useNumberSearchParams';
import { useWealthPlanningNavigate } from '../../hooks/useWealthPlanningNavigate';
import { wnSendTraceNavigationChange } from '../../utils/wn-event-utils';

interface IProps {
    title: string;
    url: string;
    isActive: boolean;
}

export const NavWealth: FunctionComponent<IProps> = ({ title, url, isActive }) => {
    const { t } = useTranslation();
    const [tab] = useNumberSearchParams('tab');
    const { partnerUuid } = useWealthPlanningNavigate();

    return (
        <ZfBox style={{ alignSelf: 'baseline' }}>
            <ZfDropdown text={title} icon="arrow_drop_down" hierarchy="tertiary" size="medium" className={isActive ? 'btn-active' : undefined}>
                <Link
                    to={{ pathname: url, search: `?tab=0` }}
                    onClick={() => wnSendTraceNavigationChange(`${url}-overview`, partnerUuid)}
                    style={{ textDecoration: 'none' }}
                >
                    <ZfDropdownItem state={isActive && tab === 0 ? 'active' : 'default'} label={t('navWealthOverview')} />
                </Link>
                <Link
                    to={{ pathname: url, search: `?tab=1` }}
                    onClick={() => wnSendTraceNavigationChange(`${url}-cashflow`, partnerUuid)}
                    style={{ textDecoration: 'none' }}
                >
                    <ZfDropdownItem state={isActive && tab === 1 ? 'active' : 'default'} label={t('cashflow')} />
                </Link>
            </ZfDropdown>
        </ZfBox>
    );
};
